import { render } from "./FilterClaimComponent.vue?vue&type=template&id=434c8f62"
import script from "./FilterClaimComponent.vue?vue&type=script&lang=js"
export * from "./FilterClaimComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__